import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { IUserDocument, IExtendedUserExceptionNotificationSetting } from "../../models"
import Table from "../../components/common/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, Tabs, Tab, FontIcon } from "material-ui"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as loginActions from "../../actions/LoginActions"
import _ from "lodash"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../components/layout/TableActionBar"
import AddSupervisorNotificationSettingDialog from "./AddSupervisorNotificationSettingDialog"
import * as notifyHelper from "../../helpers/notifyHelper"
import { green500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
interface IState {
	totalSubscriptions: IExtendedUserExceptionNotificationSetting[]
	selectedSubscriptions: IExtendedUserExceptionNotificationSetting[]
	openAddNotificationSubscriptionDialog: boolean
	editSubscription: IExtendedUserExceptionNotificationSetting
	total: number
	offset: number
	limit: number
}

export default class SupervisorNotificationSetting extends React.Component<{}, IState> {
	constructor(props) {
		super(props)
		const loggedInUser = AuthenticationStore.getLoggedInUser() as IUserDocument
		const totalSubscriptions = loggedInUser.NotificationSettings && loggedInUser.NotificationSettings.ExceptionNotificationSettings ?
			notifyHelper.convertSubscriptionsToSubscriptionsForUI(loggedInUser.NotificationSettings.ExceptionNotificationSettings) : []
		this.state = {
			totalSubscriptions,
			selectedSubscriptions: [],
			openAddNotificationSubscriptionDialog: false,
			editSubscription: null,
			total: totalSubscriptions.length,
			offset: 0,
			limit: 10,
		}
		autobind(this)
	}

	componentDidMount() {
		AuthenticationStore.on("change", this.supervisorChangeEvent)
	}

	componentWillUnmount() {
		AuthenticationStore.removeListener("change", this.supervisorChangeEvent)
	}

	supervisorChangeEvent() {
		const loggedInUser = AuthenticationStore.getLoggedInUser() as IUserDocument
		const totalSubscriptions = loggedInUser.NotificationSettings && loggedInUser.NotificationSettings.ExceptionNotificationSettings ?
			notifyHelper.convertSubscriptionsToSubscriptionsForUI(loggedInUser.NotificationSettings.ExceptionNotificationSettings) : []
		this.setState({
			totalSubscriptions,
			selectedSubscriptions: [],
			openAddNotificationSubscriptionDialog: false,
			editSubscription: null,
			total: totalSubscriptions.length,
			offset: 0,
		})
	}

	updateLoggedInUser(successMsg: string) {
		const loggedInUser = _.cloneDeep(AuthenticationStore.getLoggedInUser())
		if (!loggedInUser.NotificationSettings) {
			loggedInUser.NotificationSettings = {
				ExceptionNotificationSettings: notifyHelper.convertSubscriptionsForUIToSubscriptions(_.cloneDeep(this.state.totalSubscriptions))
			}
		}
		else {
			loggedInUser.NotificationSettings.ExceptionNotificationSettings = notifyHelper.convertSubscriptionsForUIToSubscriptions(_.cloneDeep(this.state.totalSubscriptions))
		}
		loginActions.updateLoggedInUser(loggedInUser.Id, loggedInUser, () => AppStateStore.setProgressSnackbarContent(successMsg))
	}

	handleAddSubscription(subscription) {
		AppStateStore.setProgressSnackbarContent("loading")
		const totalSubscriptions = this.state.totalSubscriptions.slice()
		totalSubscriptions.push(subscription)
		this.setState({ totalSubscriptions, openAddNotificationSubscriptionDialog: false, editSubscription: null }, () =>
			this.updateLoggedInUser(strings.Successfully_added)
		)
	}

	handleUpdateSubscription(subscription: IExtendedUserExceptionNotificationSetting) {
		AppStateStore.setProgressSnackbarContent("loading")
		const totalSubscriptions = this.state.totalSubscriptions.slice()
		totalSubscriptions[subscription.Id] = subscription
		this.setState({ totalSubscriptions, openAddNotificationSubscriptionDialog: false, editSubscription: null }, () =>
			this.updateLoggedInUser(strings.Successfully_updated)
		)
	}

	render() {
		const pageSubscriptions = this.state.totalSubscriptions.slice(this.state.offset, this.state.offset + this.state.limit)
		return (
			<div style={{ margin: -16 }}>
				<Tabs>
					<Tab label={strings.Subscriptions.toUpperCase()}>
						<FloatingActionButton
							className="fixed-add"
							style={{ top: -28, right: 20, zIndex: 998 }}
							secondary={true}
							onTouchTap={() => this.setState({ openAddNotificationSubscriptionDialog: true, editSubscription: null })}
						>
							<ContentAdd />
						</FloatingActionButton>
						<div style={{ paddingTop: 30 }}>
							<TableActionBar
								searchText=""
								rowSelectionCount={this.state.selectedSubscriptions.length}
								singleSelectedMessage={strings.Subscription_Selected}
								multipleSelectedMessage={strings.Subscriptions_Selected}
								title={strings.Subscriptions}
								titleStyle={{ fontSize: 16 }}
								bodyStyle={{ padding: 20, fontWeight: 500 }}
								onDeleteClick={() =>
									AppStateStore.setConfirmDialogContent({
										content: strings.Are_you_sure_you_want_to_delete_the_selected_subscriptions,
										confirm: () => {
											AppStateStore.setProgressSnackbarContent("loading")
											this.setState({ totalSubscriptions: this.state.totalSubscriptions.filter(i => !this.state.selectedSubscriptions.map(e => e.Id).includes(i.Id)), selectedSubscriptions: [], openAddNotificationSubscriptionDialog: false, editSubscription: null }, () =>
												this.updateLoggedInUser(strings.Successfully_deleted)
											)
										}
									})
								}
							/>
							<div>
								{this.state.totalSubscriptions.length === 0 ?
									<h2 style={{ textAlign: "center", fontSize: 25, paddingTop: 50, fontWeight: "bold" }}>
										{strings.No_Subscription}
									</h2> :
									<Table
										allowClickRow
										items={pageSubscriptions}
										selectedItems={this.state.selectedSubscriptions}
										handleClickRow={editSubscription => this.setState({ openAddNotificationSubscriptionDialog: true, editSubscription })}
										handleSelect={selectedSubscriptions => this.setState({ selectedSubscriptions })}
										total={this.state.total}
										offset={this.state.offset}
										limit={this.state.limit}
										limitOptions={[10, 20, 50]}
										onPageClick={offset => this.setState({ offset, selectedSubscriptions: [] })}
										onLimitChange={limit => this.setState({ limit, offset: 0, selectedSubscriptions: [] })}
									>
										<TableHeader>
											<TableRow>
												<TableHeaderColumn>{strings.Exception_Type}</TableHeaderColumn>
												<TableHeaderColumn>{strings.Description}</TableHeaderColumn>
												<TableHeaderColumn>{strings.Notify_Method}</TableHeaderColumn>
												<TableHeaderColumn>{strings.Hierarchy}</TableHeaderColumn>
												<TableHeaderColumn style={{ textAlign: "center", width: 125 }}>{strings.Include_Child_Hierarchies}</TableHeaderColumn>
												{AccountStore.getSupervisorDirectReportEnabled() &&
													<TableHeaderColumn style={{ textAlign: "center", width: 100 }}>{strings.Direct_Reports_Only}</TableHeaderColumn>
												}
											</TableRow>
										</TableHeader>
										<TableBody deselectOnClickaway={false}>
											{pageSubscriptions.map((subscription, index) =>
												<TableRow selected={this.state.selectedSubscriptions.find(i => i.Id === (this.state.offset + index)) ? true : false} key={index}>
													<TableRowColumn>
														{notifyHelper.getExceptionTypeName(subscription.ExceptionTypeForUI)}
													</TableRowColumn>
													<TableRowColumn>{subscription.Description}</TableRowColumn>
													<TableRowColumn>
														{notifyHelper.getNotifyMethodsName(notifyHelper.getNotifyMethods(subscription.SendEmailNotifications, subscription.SendPushNotifications, subscription.SendSmsNotifications, subscription.SendAppNotifications))}
													</TableRowColumn>
													<TableRowColumn>
														{hierarchyHelper.getFullyQualifiedLevelNameById(subscription.HierarchyId)}
													</TableRowColumn>
													<TableRowColumn style={{ textAlign: "center", width: 125 }}>
														{subscription.IncludeChildHierarchies &&
															<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
														}
													</TableRowColumn>
													{AccountStore.getSupervisorDirectReportEnabled() &&
														<TableRowColumn style={{ textAlign: "center", width: 100 }}>
															{subscription.RestrictToDirectReports &&
																<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
															}
														</TableRowColumn>
													}
												</TableRow>
											)}
										</TableBody>
									</Table>
								}
							</div>
						</div>
					</Tab>
				</Tabs>
				{this.state.openAddNotificationSubscriptionDialog &&
					<AddSupervisorNotificationSettingDialog
						existingSubscriptions={this.state.totalSubscriptions}
						editSubscription={this.state.editSubscription}
						handleClose={() => this.setState({ openAddNotificationSubscriptionDialog: false, editSubscription: null })}
						handleAdd={this.handleAddSubscription}
						handleUpdate={this.handleUpdateSubscription}
					/>
				}
			</div >
		)
	}
}